import {HttpClient} from "@angular/common/http";
import {Injectable} from "@angular/core";
import {Observable} from "rxjs";
import {environment} from "../../../environments/environment";
import {KeycloakRole} from "../../models/keycloak-role";
import { map } from 'rxjs/operators';

@Injectable()
export class AttributesControllerService {

  private baseUrl: string = environment.PARTC_URL;
  private keycloakBaseUrl: string = environment.KEYCLOAK_URL + "admin/realms/" + environment.KEYCLOAK_REALM;

  constructor(private http: HttpClient) {
  }

  public getAttributesFull(): Observable<any> {
    return this.http.get(this.baseUrl + "roles/full");
  }

  public getAttributes(): Observable<any> {
    if (Boolean(environment.KEYCLOAK_ACTIVE)) {
      return (this.http.get(this.keycloakBaseUrl + "/roles") as Observable<KeycloakRole[]>)
          .pipe(map((roles) => {
            return roles.map((role) => {
              return role.name;
            });
          }));
    }
    return this.http.get(this.baseUrl + "roles");
  }

}
